import { MedicationForm } from "src/api/types";

type Templates = Record<MedicationForm, Partial<Record<string, string>>>;

export const mapInstructionTemplateToPharmacy: Record<string, Templates> = {
  Revive: {
    injectable: {
      "Weight loss":
        "Inject {{amount}} ({{dosage}}) once weekly SQ for {{duration}}",
    },
    oral: {},
    dropper: {},
    topical: {},
  },
  Vios: {
    injectable: {
      "Weight loss":
        "Inject {{amount}} ({{dosage}}) once weekly SQ for {{duration}}",
    },
    dropper: {},
    oral: {},
    topical: {},
  },
  Choice: {
    injectable: {
      "Weight loss": "Inject {{amount}} ({{dosage}}) below the skin weekly",
    },
    dropper: {},
    oral: {
      "Weight loss": "Take {{amount}} daily",
      "Birth control": "Take 1 tablet by mouth once daily.",
      "Hair loss": "Take {{amount}} daily with meals.",
      "Skin care": "Take {{amount}} daily with meals.",
      Nausea: "Take {{amount}} daily with meals.",
      "Mental health": "Take 1 tablet by mouth once daily.",
    },
    topical: {},
  },
  Empower: {
    injectable: {
      "Weight loss": "{{week}} Inject {{amount}} subcutaneously once a week",
    },
    oral: {
      "Weight loss": "Take {{amount}} daily",
      "Hair loss": "Take {{amount}} daily with meals.",
      Nausea: "Take {{amount}} daily with meals.",
      "Erectile dysfunction":
        "Take {{amount}} about 30 to 60 minutes before sexual activity.",
      "Mental health": "Take 1 tablet by mouth once daily.",
      Supplements: "Take 1 tablet by mouth once daily.",
      Sleep: "Take 1 tablet by mouth once daily.",
    },

    dropper: {},
    topical: {},
  },
  Hallandale: {
    injectable: {
      "Weight loss":
        "Inject {{amount}} ({{dosage}}) subcutaneously (i.e. under the skin) once per week for four weeks.",
    },
    dropper: {},
    oral: {},
    topical: {},
  },
  Curexa: {
    injectable: {},
    dropper: {},
    oral: { "Birth control": "Take 1 tablet by mouth once daily." },
    topical: {},
  },
};
